import { Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import BasicInfoSection from "./BasicInfoSection";
import ModulesSection from "./ModulesSection";
import CourseDefinitionsSection from "./CourseDefinitionsSection";
import PrerequisitesSection from "./PrerequisitesSection";

const ShowSpecializationsCurricula = () => {
  return (
    <Show
      title="Детайли на учебен план"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <BasicInfoSection />
        <ModulesSection />
        <CourseDefinitionsSection />
        <PrerequisitesSection />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowSpecializationsCurricula;
